import React from 'react';
import appointments from '../../../../services/appointments/index';
import doctors from '../../../../services/doctors/index';
import users from '../../../../services/users/index';
import diagnostics from '../../../../services/diagnostics/index';
import patients from '../../../../services/patients/index';
//import appointmentDetails from '../../../../appointment-detais.svg';
import "./style.css";
import Header from './components/header/index';
import { format, startOfDay } from 'date-fns';
import { withRouter } from 'react-router-dom';
import ConfirmComponent from '../../../../components/confirm/index';
import AddPaymentModal from '../registers/scenes/patient-details/components/add-pay-modal/index';
import withDoctorModal from '../../hocs/doctor-details/index';
import { from24To12 } from '../../../../services/utilities';
const esLocale = require('date-fns/locale/es')
const images = require("../../../../images.json");
const appointmentDetails = images["appointment-detais"]

export default withDoctorModal(
    withRouter(class AppointmentDetails extends React.Component {
        state = {
            appointment: null,
            doctor: null,
            diagnostic: null,
            user: null,
            patient: null,
            loading: true,
            modal: ""
        }

        componentWillMount() {
            let {appointment, chair, timestamp} = this.props.match.params;
            appointments.findOne({_id: appointment}, (err, appointment) =>{
                this.setState({appointment: appointment})
                doctors.findOne({_id: appointment.doctor}, (err, doctor) => {
                    this.setState({doctor: doctor})
                })
                users.findOne({_id: appointment.user}, (err, user) => {
                    this.setState({user: user})
                })
                if(appointment.old)
                    this.setState({diagnostic: {
                        name: appointment.diagnostic
                    }})
                else
                    diagnostics.findOne({_id: appointment.diagnostic}, (err, diagnostic) => {
                        this.setState({diagnostic: diagnostic})
                    })
                patients.findOne({_id: appointment.patient}, (err, patient) => {
                    this.setState({patient: patient, loading: false, timestamp: timestamp, chair: chair})
                })
            })
        }

        get canCancel() {
            return (startOfDay(new Date().getTime()) <= Number(this.state.appointment.date))
        }

        getDateString = () => {
            return format(
                new Date(Number(this.state.appointment.date)),
                "DD/MMMM/YYYY",
                {locale: esLocale},
            )
        }

        getDentistName = () => {
            if(!this.state.doctor)
                return "otro"
            return `${this.state.doctor.name} ${this.state.doctor.lastname}`
        }

        getPatientName = () => {
            return `${this.state.patient.name} ${this.state.patient.lastname}`
        }

        getDescription = () => {
            return this.state.appointment.description == "" ? "Sin descripción" : this.state.appointment.description
        }

        goBack = () => {
            if(this.state.timestamp && this.state.chair)
                this.props.history.push(`/home/pick-day/${this.state.timestamp}/${this.state.chair}`);
            else
                this.props.history.goBack();
        }

        cancelAppointment = () => {
            appointments.remove({_id: this.state.appointment._id}, (err, status) => {
                this.goBack();
            })
        }

        updatePayment = (pay) => {
            let appointment = Object.assign({}, this.state.appointment);
            appointment.pay = pay

            this.setState({appointment: appointment})
        }

        openConfirm = (modal) => this.setState({modal: modal})
        closeConfirm = () => this.setState({modal: ""})

        openPatient = (patientId) => {
            this.props.history.push(`/registers/details/${patientId}`)
        }

        render() {
            if(this.state.loading)
                return <a className="button is-loading">Loading</a>

            return (
                <React.Fragment>
                    <div className="DetailsHeader">
                        <Header timestamp={this.state.timestamp} chair={this.state.chair} />
                    </div>
                    <div className="AppointmentDetails">
                        <div className="card">
                            <div className="card-header">
                                <p className="card-header-title">Detalles de cita</p>
                                <a className="card-header-icon header-button"
                                    onClick={() => this.openConfirm("payment")}
                                >
                                    Agregar pago
                                </a>
                            </div>
                            <div className="card-content">
                                <div className="details-image">
                                    <figure className="image is-128x128">
                                        <img src={appointmentDetails} alt="Details"/>
                                    </figure>
                                    <div className="details-wrapper">
                                        <p><b>Fecha de la cita:</b> {this.getDateString()}</p>
                                        <p><b>Hora:</b> {from24To12(this.state.appointment.time)}</p>
                                        <p><b>Silla: </b> {this.state.appointment.chair}</p>
                                    </div>
                                </div>
                                <div className="details-info">
                                    <p><b>Cliente:</b> <a onClick={() => this.openPatient(this.state.patient._id)}>{this.getPatientName()}</a></p><br />
                                    <p><b>Teléfono del cliente: </b> {this.state.patient.phone}</p> <br />
                                    <p><b>Pago: </b> ${this.state.appointment.pay}</p> <br />
                                    <p><b>Servicio: </b> {this.state.diagnostic.name}</p><br />
                                    {this.state.appointment.doctor &&
                                    <div><p><b>Empleado: </b>
                                        <a onClick={() => this.props.openDoctorDetails(this.state.doctor)}>
                                            {this.getDentistName()}
                                        </a>
                                    </p> <br /></div>}
                                    <p><b>Agendó: </b> {this.state.user.userName}</p> <br />
                                    {this.state.appointment.createdAt &&
                                    <React.Fragment>
                                        <p><b>Fecha en que se agendó: </b> {
                                            format(
                                                new Date(Number(this.state.appointment.createdAt)),
                                                "DD/MMMM/YYYY",
                                                {locale: esLocale},
                                            )
                                        }</p> <br />
                                    </React.Fragment>}
                                    <p><b>Descripción: </b> {this.getDescription()}</p> <br />
                                </div>
                            </div>
                            {this.canCancel &&
                            <div className="card-footer"
                                style={{padding: 7, justifyContent: "flex-end"}}>
                                <button className="button is-danger"
                                    onClick={() => this.openConfirm("confirm")}
                                >
                                    Cancelar cita
                                </button>
                            </div>}
                        </div>
                    </div>
                    <ConfirmComponent header="Cancelar cita"
                        isActive={this.state.modal == "confirm"}
                        close={this.closeConfirm}
                        onSubmit={this.cancelAppointment}
                        text="¿Está seguro que desea cancelar la cita?"
                    />
                    <AddPaymentModal user={this.props.user}
                        patient={this.state.patient}
                        appointment={this.state.appointment}
                        close={this.closeConfirm}
                        updatePayment={this.updatePayment}
                        isActive={this.state.modal == "payment"} />
                </React.Fragment>
            );
        }
    })
)


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/appointment-details/index.js